"use client";

import { List, LayoutGrid, Map } from "lucide-react";
import { useTranslations } from "next-intl";

export type ViewMode = "list" | "grid" | "map";

interface ViewSwitcherProps {
  view: ViewMode;
  onViewChange: (view: ViewMode) => void;
  onMapHover?: () => void;
}

export function ViewSwitcher({ view, onViewChange, onMapHover }: ViewSwitcherProps) {
  const t = useTranslations("Events");
  const options = [
    { value: "list", icon: List, label: t("list") },
    { value: "grid", icon: LayoutGrid, label: t("grid") },
    { value: "map", icon: Map, label: t("map") },
  ] as const;

  return (
    <div className="flex w-fit shrink-0 gap-1 rounded-lg border border-neutral-800 bg-surface p-1">
      {options.map(({ value, icon: Icon, label }) => (
        <button
          key={value}
          onClick={() => onViewChange(value)}
          onMouseEnter={value === "map" ? onMapHover : undefined}
          onFocus={value === "map" ? onMapHover : undefined}
          aria-label={label}
          aria-pressed={view === value}
          className={`flex cursor-pointer items-center gap-2 rounded-md px-2.5 py-1.5 font-mono text-xs transition-colors sm:px-3 ${
            view === value
              ? "bg-acid text-black"
              : "text-neutral-400 hover:text-white"
          }`}
        >
          <Icon className="h-3.5 w-3.5" />
          <span className="max-sm:hidden">{label}</span>
        </button>
      ))}
    </div>
  );
}
